const commonTokens = {

};

const roleColors = {
  PRIMARY_CLIENT: '#fad02c',
  DEFAULT: '#1890ff',
};

export const roleThemes = Object.fromEntries(
  Object.entries(roleColors).map(([role, color]) => [
    role,
    {
      token: {
        colorPrimary: color,
        ...commonTokens,
      },
    },
  ])
);